import React from 'react';
import PropTypes from 'prop-types';
import { Check } from 'react-feather';
import './checkbox-group-item.scss';
import clsx from 'clsx';
import Icon, { IconColors, IconSizes } from '../icon';
import Image from '../image';

const CheckboxGroupItem = ({
  itemId, image, text, supportingText, selected, disabled, onSelect, showSelect, renderIcon,
}) => {
  const handleClick = () => {
    if (!disabled && onSelect && typeof onSelect === 'function') {
      onSelect(itemId);
    }
  };

  const getIconImageView = () => {
    if (image) {
      return (
        <div className="cgi-icon-image">
          <Image alt="item-image" src={image} className="cgi-image" />
        </div>
      );
    }
    if (renderIcon) {
      return (
        // Change here
        <div className="cgi-icon-image">
          {renderIcon({
            size: IconSizes.MEDIUM,
            color: disabled ? IconColors.GREY : IconColors.PRIMARY,
          })}
        </div>
      );
    }
    return null;
  };

  const getTextView = () => (
    <div className="cgi-texts">
      <div className="cgi-primary-text">{text}</div>
      <div className="cgi-helper-text">{supportingText}</div>
    </div>
  );

  const getCheckboxView = () => (showSelect ? (
    <div className="cgi-checkbox">
      {selected ? (
        <Icon
          icon={Check}
          color={IconColors.LIGHT}
          size={IconSizes.SMALL}
          className="cgi-check-icon"
        />
      ) : null}
    </div>
  ) : null);

  return (
    <div
      className={clsx('checkbox-group-item-cont', {
        'cgi-selected': selected,
        'cgi-disabled': disabled,
        'cgi-selectable': showSelect,
      })}
      role={disabled ? '' : 'button'}
      tabIndex={disabled ? -1 : 0}
      onClick={handleClick}
    >
      {getIconImageView()}
      {getTextView()}
      {getCheckboxView()}
    </div>
  );
};

CheckboxGroupItem.propTypes = {
  itemId: PropTypes.string,
  renderIcon: PropTypes.func,
  image: PropTypes.string,
  text: PropTypes.string,
  supportingText: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  showSelect: PropTypes.bool,
};

CheckboxGroupItem.defaultProps = {
  itemId: '',
  renderIcon: null,
  image: '',
  text: '',
  supportingText: '',
  disabled: false,
  selected: false,
  onSelect: () => {},
  showSelect: true,
};

export {
  CheckboxGroupItem as default,
};
